export const environment = {
    production: false,
    apiUrl: 'https://signcorc-dev-api.azurewebsites.net',
    msalConfig: {
        clientId: '9fc57342-c80b-4060-9ddf-fc85324b4324',
        authority:
            'https://signcoauth.b2clogin.com/signcoauth.onmicrosoft.com/B2C_1A_CUSTOM_SIGNIN',
        knownAuthority: 'signcoauth.b2clogin.com',
        scopes: ['https://signcoauth.onmicrosoft.com/signcoserv/user.access'],
    },
    signalR: {
        hubUrl: 'https://signcorc-dev-api.azurewebsites.net/hubs/device',
    },
    session: {
        timeoutWarningSeconds: 60,
    },
    features: {
        activityLog: true,
    },
};
